import { supabase } from './supabase';

export async function fetchLabourRates(projectId) {
  const [{ data: globalRates }, { data: projectRates }, { data: settings }] = await Promise.all([
    supabase.from('labour_rates').select('trade, rate_per_hour'),
    projectId
      ? supabase.from('project_labour_rates').select('trade, rate_per_hour').eq('project_id', projectId)
      : Promise.resolve({ data: [] }),
    supabase.from('commercial_settings').select('setting_key, setting_value'),
  ]);

  const globalMap = {};
  (globalRates || []).forEach(r => { globalMap[r.trade] = parseFloat(r.rate_per_hour) || 0; });

  const projectMap = {};
  (projectRates || []).forEach(r => { projectMap[r.trade] = parseFloat(r.rate_per_hour) || 0; });

  const settingsMap = {};
  (settings || []).forEach(s => { settingsMap[s.setting_key] = parseFloat(s.setting_value) || 0; });

  function getRateForTrade(trade) {
    if (trade in projectMap) return projectMap[trade];
    return globalMap[trade] ?? 0;
  }

  return {
    globalMap,
    projectMap,
    materialsUplift: settingsMap['materials_uplift_pct'] ?? 25,
    plantUplift: settingsMap['plant_uplift_pct'] ?? 0,
    getRateForTrade,
  };
}

export function calcDayworkSheetCost(labour, materials, plant, rates) {
  if (!rates) return 0;
  const matMult  = 1 + (rates.materialsUplift / 100);
  const plantMult = 1 + (rates.plantUplift / 100);

  const labourCost = (labour || []).reduce((s, l) =>
    s + (parseFloat(l.hours_calculated) || 0) * rates.getRateForTrade(l.trade), 0);

  const materialsCost = (materials || []).reduce((s, m) =>
    s + (parseFloat(m.quantity) || 0) * (parseFloat(m.price_per_unit) || 0) * matMult, 0);

  const plantCost = (plant || []).reduce((s, p) =>
    s + (parseFloat(p.quantity) || 0) * (parseFloat(p.rate) || 0) * plantMult, 0);

  return labourCost + materialsCost + plantCost;
}
